import HistoryNameTP from './historyName';

export default {
  HistoryNameTP,
};
